import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGroupChatContext } from "../../hooks/GroupChatContextWrapper";
import { useMessageContext } from "../../hooks/MessageContext";
import ChatNavigation from "../chat/chat-navigation";
import EditGroupChatModal from "../group-chat/edit-group-chat-modal";
import GroupMembersList from "../group-chat/group-members-list";
import { SubmitButton } from "../shared/buttons/submit-button";
import Typography from "../shared/typography";
import ChatMessagesLayout from "./chat-messages-layout";

function GroupChatLayout() {
  const { groupChatId } = useParams<{ groupChatId: string }>();
  const { setChatType } = useMessageContext();
  const { selectedGroupChat, selectGroupChat } = useGroupChatContext();
  const [editOpen, setEditOpen] = useState(false);

  useEffect(() => {
    if (groupChatId) {
      setChatType("group_chat", groupChatId);
      selectGroupChat(groupChatId);
    }
    return () => {
      setChatType("ai_chat");
    };
  }, [groupChatId, setChatType, selectGroupChat]);

  const headerHeight = "4rem";
  const chatInputHeight = "5rem";

  return (
    <main
      className="max-w-8xl mx-auto px-4 py-8 sm:px-6 lg:px-8"
      style={{ height: "var(--app-height)" }}
    >
      <ChatNavigation />
      <div className="mb-4 flex items-center justify-between">
        <Typography variant="h4" className="text-terracotta">
          {selectedGroupChat?.name || "Group Chat"}
        </Typography>
        <SubmitButton size="sm" onClick={() => setEditOpen(true)}>
          Edit
        </SubmitButton>
      </div>
      {groupChatId && <GroupMembersList groupId={groupChatId} />}
      <div
        className="relative h-full"
        style={{
          height: `calc(var(--app-height) - ${headerHeight} - ${chatInputHeight})`,
          marginBottom: chatInputHeight,
        }}
      >
        <ChatMessagesLayout />
      </div>
      {groupChatId && (
        <EditGroupChatModal
          groupId={groupChatId}
          isOpen={editOpen}
          onClose={() => setEditOpen(false)}
        />
      )}
    </main>
  );
}

export default GroupChatLayout;
